<template>
  <v-container style="background-color: #fafafa">
    <v-row>
      <v-col cols="12" class="text-center">
        <h2>Resultado do funil de vendas</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="4">
        <ResultDisplay title="META" :value="`R$ ${meta}`"/>
      </v-col>
      <v-col cols="12" sm="4">
        <ResultDisplay title="VENDAS REALIZADAS" :value="`${vendas}`"/>
      </v-col>
      <v-col cols="12" sm="4">
        <ResultDisplay title="CONVERSÃO" :value="`${conversao}%`"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ResultDisplay from './ResultDisplay';
export default {
  components: {
    ResultDisplay
  },
  props: {
    meta: Number | String,
    vendas: Number | String,
    conversao: Number | String
  }
};
</script>

<style scoped>
.results-title {
}
</style>